import { render, staticRenderFns } from "./bullSemenIssue.vue?vue&type=template&id=362c97c0&scoped=true&"
import script from "./bullSemenIssue.vue?vue&type=script&lang=js&"
export * from "./bullSemenIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c97c0",
  null
  
)

export default component.exports